/**
 * Circuit Breakers Component
 * Displays all 7 circuit breaker levels and their status
 */

import { useCircuitBreakers } from '../api/client';

export function CircuitBreakers() {
  const { data, isLoading, error } = useCircuitBreakers();

  if (isLoading) {
    return (
      <div className="card">
        <div className="loading">Loading circuit breakers...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card">
        <div className="error">Error loading circuit breakers: {error.message}</div>
      </div>
    );
  }

  const breakers = data?.circuitBreakers;
  if (!breakers) return null;

  const statusBadge = breakers.triggered
    ? breakers.action === 'HALT'
      ? 'badge-danger'
      : breakers.action === 'EMERGENCY'
      ? 'badge-danger'
      : 'badge-warning'
    : 'badge-success';

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">Circuit Breakers</h2>
        <span className={`card-badge ${statusBadge}`}>
          {breakers.triggered ? breakers.action : 'ALL CLEAR'}
        </span>
      </div>

      {breakers.triggered && breakers.reason && (
        <div
          className="error"
          style={{
            marginBottom: '1rem',
            padding: '0.75rem',
            fontSize: '0.875rem',
          }}
        >
          <strong>Active Alert:</strong> {breakers.reason}
        </div>
      )}

      <div style={{ marginBottom: '1rem' }}>
        <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
          Trading Status
        </div>
        <div style={{ display: 'flex', gap: '1rem', fontSize: '0.875rem' }}>
          <div>
            Can Trade:{' '}
            <strong style={{ color: breakers.canTrade ? 'var(--accent-green)' : 'var(--accent-red)' }}>
              {breakers.canTrade ? 'YES' : 'NO'}
            </strong>
          </div>
          <div>
            Can Enter:{' '}
            <strong style={{ color: breakers.canEnter ? 'var(--accent-green)' : 'var(--accent-red)' }}>
              {breakers.canEnter ? 'YES' : 'NO'}
            </strong>
          </div>
          <div>
            Can Exit:{' '}
            <strong style={{ color: breakers.canExit ? 'var(--accent-green)' : 'var(--accent-red)' }}>
              {breakers.canExit ? 'YES' : 'NO'}
            </strong>
          </div>
        </div>
      </div>

      {/* Circuit Breaker Levels */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {breakers.levels.map((level) => (
          <div key={level.level} className="circuit-breaker-level">
            <div
              className={`level-badge ${level.triggered ? 'triggered' : ''}`}
              style={{
                backgroundColor: level.triggered ? 'var(--accent-red)' : 'var(--bg-secondary)',
                color: level.triggered ? 'white' : 'var(--text-secondary)',
              }}
            >
              {level.level}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: '0.875rem' }}>{level.name}</div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                Status: {level.status}
              </div>
            </div>
            <div
              className="status-dot"
              style={{
                backgroundColor: level.triggered
                  ? 'var(--accent-red)'
                  : 'var(--accent-green)',
                boxShadow: level.triggered
                  ? '0 0 8px var(--accent-red)'
                  : '0 0 8px var(--accent-green)',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
